// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dracovish: PokeData = {
  "id": 882,
  "name": "dracovish",
  "height": 23,
  "weight": 2150,
  "base_experience": 177,
  "types": [
    PokeType.WATER,
    PokeType.DRAGON
  ],
  "api_moves": [
    "stomp",
    "tackle",
    "bite",
    "water-gun",
    "super-fang",
    "protect",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "dragon-pulse",
    "dragon-rush",
    "brutal-swing",
    "fishious-rend"
  ],
  "moves": [
    "tackle",
    "bite",
    "protect",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "dragon-pulse",
    "dragon-rush",
    "rain-dance",
    "inner-spirit",
    "brine",
    "whirlpool",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 463,
    "item": null,
    "species": [
      {
        "name": "dracovish",
        "order": 882,
        "types": [
          PokeType.WATER,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 141,
    "speed": 118,
    "ability_power": 141
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
